<template>
  <v-container
    id="login"
    fill-height
    tag="section"
    class="mt-15"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <v-card
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
          style="margin-top:50px"
        >
          <center>
            <div id="sidebarLogo">
             <img width='150' id="whitelogo" src="../assets/si_white.svg" />
            </div>
           </center> 
          <template>
            <div class="text-center">
              <v-btn
                v-for="(social, i) in socials"
                :key="i"
                :href="social.href"
                class="ma-1"
                icon
                rel="noopener"
                target="_blank"
              >
                <v-icon
                  v-text="social.icon"
                />
              </v-btn>
            </div>
          </template>

          <v-card-text class="text-center">


            <form @submit.prevent="login">
              <v-text-field
                v-model="email"
                color="primary"
                label="Email..."
                prepend-icon="mdi-email"
              />

              <v-text-field
                v-model="pass"
                class="mb-8"
                type="password"
                color="primary"
                label="Password..."
                prepend-icon="mdi-lock-outline"
              />
              <v-btn color="primary" outlined type="submit" >
                Login
              </v-btn>
            </form>


            <v-snackbar top v-model="authError" color="red" class="pl-10">
              <v-icon>mdi-alert-circle-outline</v-icon> <span class="font-weight-bold">The combination of the chosen username and password is invalid!</span>
            </v-snackbar>
            <!-- No user found with this auth code -->
            <v-snackbar top v-model="showNoUserFound" color="red" class="pl-10">
              <v-icon>mdi-alert-circle-outline</v-icon> <span class="font-weight-bold">We could not find the user you are looking for. <br>Please contact the support at contact@searchinsights.de</span>
            </v-snackbar>
            <!-- No user found with this auth code -->
            <v-snackbar top v-model="verificationError" color="red" class="pl-10">
              <v-icon>mdi-alert-circle-outline</v-icon> <span class="font-weight-bold">Your email adress has not been verfied yet! <br>Please check your email account for our activation-link.</span>
            </v-snackbar>
            <!-- auth true -->          
            <v-snackbar top v-model="showSuccessMessage" color="green" class="pl-10">
              <v-icon>mdi-check-circle-outline</v-icon> <span class="font-weight-bold">Your email adress has been verified!</span>
            </v-snackbar>
             <!-- password will be resetted -->          
            <v-snackbar top v-model="showResetPasswordMessage" color="green" class="pl-10">
              <v-icon>mdi-check-circle-outline</v-icon> <span class="font-weight-bold">We have sent you a link to reset your password!<br>Please check your email account.</span>
            </v-snackbar>
          </v-card-text>
        </v-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
import auth from '../components/helper/auth'
  export default {
    name: 'Login',

    components: {
    },

    data: () => ({
      auth: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
      email: '',
      pass: '',
      dialog: false,
      authError: false,
      verificationError: false,
      showSuccessMessage: false,
      showNoUserFound: false,
      showResetPasswordMessage: false,
      socials: [
        // {
        //   href: '#',
        //   icon: 'mdi-facebook-box'
        // },
        // {
        //   href: '#',
        //   icon: 'mdi-twitter'
        // },
        // {
        //   href: '#',
        //   icon: 'mdi-github-box'
        // }
      ]
    }),
     methods: {
      checkEmail(email){
        if(email.length> 0){
          this.$http.post(process.env.VUE_APP_APIURL+'/user/resetpassword', {email: email},{ headers: {'Authorization': this.auth}})
          .then(response =>{
            console.log(response)
            if(response.body.user_found){
              this.showResetPasswordMessage = true;
              try {
                this.$matomo.trackEvent("Login", "resetPassword", email , "" );
              } catch (error) {
                console.log(error)
                console.log("matomo blocked")
              }
            }else{
              this.showNoUserFound = true;
              try {
                this.$matomo.trackEvent("Login", "resetPassword - no user found ", email , "" );
              } catch (error) {
                console.log(error)
                console.log("matomo blocked")
              }
              
            }
            
          }).catch(error=>{
            // if(error.body.error.notallowed){
            //   // TODO: Website redirect
            //   this.notAllowed = true;
            //   this.notAllowedMessage = "This email adress is not allowed to register. Please contact us: contact@searchinsights.de";
            // }else{
              //console.log(error)
            // }
            
          })
        }

        
      },
      gotoRegister(){
        try {
          this.$matomo.trackEvent("Login", "gotoRegister", "" , "" );
        } catch (error) {
          console.log(error)
          console.log("matomo blocked")
        }
        this.$router.push({ path: '/register'})
      },
      login () {
        // try {
        //   this.$matomo.trackEvent("Login", "login", "" , "" );
        // } catch (error) {
        //   console.log(error)
        //   console.log("matomo blocked")
        // }
        auth.login(this.email, this.pass, loggedIn => {
          console.log(loggedIn)
          if (loggedIn.authentication) {
            if(loggedIn.verification){
              this.$router.replace(this.$route.query.redirect || '/')
            }else{
              this.verificationError = true
            }
          } else {
            this.authError = true
          }
        })

      },
      verificateUser(){
        this.$http.get(process.env.VUE_APP_APIURL+'/user/auth/'+ this.$route.params.auth, { headers: {'Authorization': this.auth}})
            .then(response =>{
              //console.log(response.body.success)
              if(response.body.success){
                this.showSuccessMessage = true;
                try {
                  this.$matomo.trackEvent("Login", "verificateUser - verficated ", this.$route.params.auth , "" );
                } catch (error) {
                  console.log(error)
                  console.log("matomo blocked")
                }
              }else{
                this.showNoUserFound = true;
                try {
                  this.$matomo.trackEvent("Login", "verificateUser - not verficated ", this.$route.params.auth , "" );
                } catch (error) {
                  console.log(error)
                  console.log("matomo blocked")
                }
                
              }
              
            }).catch(error=>{
              // if(error.body.error.notallowed){
              //   // TODO: Website redirect
              //   this.notAllowed = true;
              //   this.notAllowedMessage = "This email adress is not allowed to register. Please contact us: contact@searchinsights.de";
              // }else{
                //console.log(error)
              // }
              
            })
      }
    },
    mounted(){
      // //console.log(this.$route.params.auth)
      if(this.$route.params.auth){
        this.verificateUser();
      }
    }
  }
</script>
<style scoped>
#passwordDialog{
  box-shadow: none !important;
}
#whitelogo{
  padding-top: 50px;
}
#sidebarLogo{
  width: 300px;
  height: 170px;
  margin-top: -50px;
  border-radius: 30px;
  margin-bottom:30px;
  background: rgb(2,226,255);
  background: linear-gradient(56deg, rgba(2,226,255,1) 0%, rgba(3,201,255,1) 0%, rgb(23, 139, 206) 100%);
}
.registerLink{
  margin-bottom:-20px;
  padding-top:25px;
  margin:0%;
}
.registerLink:hover{
  cursor: pointer;
  color: rgb(90, 90, 189);
  text-decoration: underline;
}
.forgotpw:hover{
  cursor: pointer;
  color: rgb(90, 90, 189);
  text-decoration: underline;
}

.v-card{
  border-radius: 30px;
}
.text-center{
  padding-bottom: 0px;
}
#sendmailbtn{
  margin-right: 50%;
}
</style>